import { render, staticRenderFns } from "./IntegracaoRedeDamas.vue?vue&type=template&id=42394fca"
import script from "./IntegracaoRedeDamas.vue?vue&type=script&lang=js"
export * from "./IntegracaoRedeDamas.vue?vue&type=script&lang=js"
import style0 from "./IntegracaoRedeDamas.vue?vue&type=style&index=0&id=42394fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports